import { useEffect, useState } from 'react';

const useIsServerStylesAppended = (defaultValue = false) => {
  const [isServerStylesAppended, setIsServerStylesAppended] = useState(defaultValue);

  useEffect(() => {
    const head = document.head || document.getElementsByTagName('head')[0];

    if (head.querySelector('style[data-styled]')) {
      setIsServerStylesAppended(true);
      document.querySelector('footer')?.classList.remove('sr-only');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue, setIsServerStylesAppended]);

  return isServerStylesAppended;
};

export default useIsServerStylesAppended;
